<template>
  <div class="h-auto ml-0 w-full lg:mr-3 p-3 pt-0">
    <el-tabs
      v-model="selectedTab"
      type="border-card"
      @tab-click="handleTabClick"
    >
      <el-tab-pane
        v-for="(tab, index) in tabs"
        :key="index"
        :label="tab.name"
        :name="tab.name"
      >
        <component :is="tab.componentName"></component>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
// Other imports...
import BenefitsSetups from "@/components/CompanySetups/benefitsTabs.vue";
import DocumentsList from "@/components/CompanySetups/documentsSetups/documentsList.vue";
import AssetsTabs from "@/components/CompanySetups/assetsTabs.vue";
import ClaimsTabs from "@/components/CompanySetups/claimsTabs.vue";
import CoreSetups from "@/components/CompanySetups/coreSetups/coreSetups.vue";
import TimeOffSetups from "@/components/CompanySetups/timeOffSetups/timeOffSetups.vue";
import { mapGetters } from "vuex";
import PerformanceSetups from "@/components/CompanySetups/performanceSetups/performanceSetups.vue";

export default {
  name: "SetupsTabs",
  props: ["setup"],
  components: {
    BenefitsSetups,
    DocumentsList,
    CoreSetups,
    AssetsTabs,
    TimeOffSetups,
    ClaimsTabs,
    PerformanceSetups,
  },
  data() {
    return {
      selectedTab: "Core Setups",
      tabs: [
        {
          name: "Core Setups",
          route: "core-setups",
          componentName: "CoreSetups",
        },
        {
          name: "Benefits Setups",
          route: "benefits-setups",
          componentName: "BenefitsSetups",
        },
        {
          name: "Documents Setups",
          route: "documents-setups",
          componentName: "DocumentsList",
        },
        {
          name: "Assets Setups",
          route: "assets-setups",
          componentName: "AssetsTabs",
        },
        {
          name: "Claims Setups",
          route: "claims-setups",
          componentName: "ClaimsTabs",
        },
        {
          name: "Time Off Setups",
          route: "timeoff-setups",
          componentName: "TimeOffSetups",
        },
        {
          name: "Performance Setups",
          route: "performance-setups",
          componentName: "PerformanceSetups",
        },
      ],
    };
  },

  computed: {
    routeParam() {
      return {
        outerTab: this.$route.params?.outerTab,
        innerTab: this.$route.params?.innerTab,
      };
    },
    ...mapGetters([
      "getClockInTime",
      "isUseClockedIn",
      "getOrganization",
      "getToken",
      "getLatestClockInTimeWithoutClockout",
    ]),
  },

  created() {
    // Set the selectedTab based on routeParam.outerTab when the component is created
    const outerTabIndex = parseInt(this.routeParam.outerTab);
    if (
      !isNaN(outerTabIndex) &&
      outerTabIndex >= 0 &&
      outerTabIndex < this.tabs.length
    ) {
      this.selectedTab = this.tabs[outerTabIndex].name;
    }
  },

  methods: {
    handleTabClick(tab) {
      const selectedTab = this.tabs.find((t) => t.name === tab.name);
      if (selectedTab) {
        this.$router.replace({
          name: "company-setups",
          params: { type: selectedTab.route, company: this.getOrganization },
        });
      }
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style>
.el-tabs--border-card > .el-tabs__content {
  padding: 0;
}
</style>
